import PropTypes from 'prop-types';
import { Radio } from '@evertrue/et-components';

const SolicitorPrimaryRadio = ({ solicitor, handleChange }) => {
  return (
    <div className="proposal-form--solicitor-column">
      <Radio
        label={`${solicitor.contact_id}`}
        checked={solicitor.type === 'PRIMARY'}
        value={solicitor.type}
        onChange={(selected) => {
          const type = selected ? 'PRIMARY' : 'SECONDARY';
          handleChange(solicitor.contact_id, { type });
        }}
        name="is_primary"
      >
        <span>
          <strong>{solicitor.name}</strong>
          {solicitor.type === 'PRIMARY' && <span> (Primary)</span>}
        </span>
      </Radio>
    </div>
  );
};

SolicitorPrimaryRadio.propTypes = {
  solicitor: PropTypes.shape({
    contact_id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
  }),
  handleChange: PropTypes.func.isRequired,
};

export default SolicitorPrimaryRadio;
